import { TablePaginationConfig } from "antd";



export const pagination = {
    showTotal: (total: number, range: number[]) => `Showing ${range[0]} to ${range[1]} of ${total} results`,
    showQuickJumper: false,
    showSizeChanger: false,
} as TablePaginationConfig
